import React from "react";
import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, y = 24, className = "", as: Tag = "div" }) => {
    const MotionTag = motion[Tag] || motion.div;
    return (
        <MotionTag
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.85, ease: [0.2, 0.7, 0.2, 1], delay }}
            className={className}
        >
            {children}
        </MotionTag>
    );
};

export const Overline = ({ children, className = "" }) => (
    <p className={`text-overline ${className}`}>{children}</p>
);

export const SectionDivider = () => (
    <div className="w-full border-t border-white/[0.06]" />
);

export default FadeIn;
